<template>
  <div>
    <toolbar
        :search.sync="filters.search"
        :scope.sync="filters.scope"
        :dataset-type.sync="filters.datasetType"
        :nemsis-version.sync="filters.nemsisVersion"
        :versions="supportedVersions"
        @clickAdd="editItem(null)"
    />

    <v-card
        elevation="3"
        class="ma-4"
        style="min-height: 50px;"
    >
      <schematrons-table
          :schematrons="schematrons"
          :loading="loading"
          @edit="editItem"
          @versions="showVersions"
          @delete="deleteItem"
      />
    </v-card>

    <confirmation ref="confirmationPopup" />
    <edit-schematron-dialog
        ref="editDialog"
        @saved="refresh"
    />
    <versions-dialog
        ref="versionsDialog"
        @changed="refresh"
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import { SET_TITLE } from '@/store/mutations';
import schematronsApi from '@/api/schematrons';
import Confirmation from '@/components/Confirmation';
import Toolbar from '@/components/Schematrons/Toolbar';
import SchematronsTable from '@/components/Schematrons/SchematronsTable';
import EditSchematronDialog from '@/components/Schematrons/EditSchematronDialog';
import VersionsDialog from '@/components/Schematrons/VersionsDialog';

export default {
  name: 'Schematrons',
  components: {
    Confirmation,
    Toolbar,
    SchematronsTable,
    EditSchematronDialog,
    VersionsDialog,
  },

  data() {
    return {
      loading: false,
      schematrons: [],
      supportedVersions: [],
      filters: {
        search: null,
        scope: null,
        datasetType: null,
        // Defaulted to the version the platform submits: rulesets for the next one are
        // loaded months ahead, and showing them all by default buries the live set.
        nemsisVersion: null,
      },
    };
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.refresh();
      },
    },
  },

  async mounted() {
    this[SET_TITLE](this.$t('schematrons.header'));

    const meta = await schematronsApi.getMeta();
    this.supportedVersions = meta.supportedVersions;
    // Assigning the filter triggers the watcher, which loads the list.
    this.filters.nemsisVersion = meta.version;
  },

  methods: {
    ...mapMutations([SET_TITLE]),

    async refresh() {
      this.loading = true;
      try {
        // Empty filters are dropped rather than sent as null: the backend validates them,
        // so a stray null would be a bad value rather than "no filter".
        const params = Object.fromEntries(
          Object.entries(this.filters).filter(([, value]) => value !== null && value !== ''),
        );
        const response = await schematronsApi.getSchematrons(params);
        this.schematrons = response.data;
      } finally {
        this.loading = false;
      }
    },

    editItem(item = null) {
      this.$refs.editDialog.open(item);
    },

    showVersions(item) {
      this.$refs.versionsDialog.open(item);
    },

    deleteItem(item) {
      this.$refs.confirmationPopup.showConfirm(
        this.$t('schematrons.deleteConfirmationHeading'),
        `${item.name} — ${this.$t('schematrons.deleteConfirmationText')}`,
        async () => {
          await schematronsApi.deleteSchematron(item.id);
          await this.refresh();
        },
      );
    },
  },
};
</script>
